import React from 'react'

import { Container } from './styles'

interface Props {
  children: React.ReactNode
}

/**
 * Componente LabelForm que utiliza o react-hook-form para gerenciar o estado do campo.
 * @param {Props} props - Propriedades necessárias para preencher a label
 * @returns {JSX.Element} O componente LabelForm renderizado.
 */
export const LabelForm = ({ children }: Props): JSX.Element => {
  return <Container>{`${children}`}</Container>
}
